import { Box, styled } from '@ltvco/refresh-lib/theme';

// Sticky strip that holds the report-actions bar background flush to the top
// while the report scrolls. Extracted so the sticky offset and background
// token live in one place — this was a duplicated raw `#f8f8f8` spacer in the
// Contact and Username report views. `#f8f8f8` is `background.default`.
export const StickyActionsSpacer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  position: 'sticky',
  top: 52,
  zIndex: 10,
  marginBottom: '-10px',
  marginLeft: theme.spacing(-1),
  marginRight: theme.spacing(-1),
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
  },
}));
